import { StubBearerAdapter } from "../../../services/auth/stub-adapter";
import type { ServiceKey } from "../../../services/auth/types";

/**
 * Transcribe is a stub for Phase 1. The real implementation will pass
 * idp_identifier=williamslea.com to the Cognito Hosted UI to route through
 * the correct OIDC provider (already supported in CognitoAdapterBase).
 */
export class TranscribeAuthAdapter extends StubBearerAdapter {
  readonly key: ServiceKey = "transcribe";
  readonly category = "media";
}
